import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

const MarkdownViewerModal = ({ open, file, onClose }) => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !file) return;

    if (file.endsWith(".md")) {
      setLoading(true);
      fetch(`/help_guide/${file}`)
        .then((res) => res.text())
        .then(setContent)
        .finally(() => setLoading(false));
    } else {
      setContent("");
      setLoading(false);
    }
  }, [open, file]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        Help Guide
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          ✕
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {loading && <CircularProgress />}

        {/* ✅ MARKDOWN */}
       {file?.endsWith(".md") && (
  <ReactMarkdown
    remarkPlugins={[remarkGfm]}
    rehypePlugins={[rehypeRaw]}
    components={{
        p: ({ children }) => (
        <Typography
          variant="body2"
          sx={{ mb: 2 }}   // 👈 space after each line
        >
          {children}
        </Typography>
      ),
        li: ({ children }) => (
        <li>
          <Typography
            variant="body2"
            sx={{ mb: 1 }} // 👈 space between bullets
          >
            {children}
          </Typography>
        </li>
      ),
      img: ({ src, alt }) => {
        if (!src) return null;

        // ✅ Fix relative image paths (NO plugin needed)
        const normalizedSrc = src.startsWith("http")
          ? src
          : `/help_guide/${src
              .replace(/^(\.\.\/)+/, "") // remove ../
              .replace(/^\/+/, "")}`;    // remove leading /

        return (
          <Box my={2}>
            <img
              src={normalizedSrc}
              alt={alt}
              style={{
                width: "100%",
                borderRadius: "8px",
                border: "1px solid #ddd",
              }}
            />
          </Box>
        );
      },
    }}
  >
    {content}
  </ReactMarkdown>
)}


        {/* ✅ VIDEO */}
        {/* {file?.endsWith(".mp4") && (
             <Box sx={{ mt: 2, mb: 5 }}>
          <video
            src={`/help_guide/${file}`}
            controls
            autoPlay
            style={{
              width: "100%",
              maxHeight: "600px",
              borderRadius: "8px",
              background: "#000",
            }}
          />
          </Box>
        )} */}
        {file?.endsWith(".mp4") && (
  <Box sx={{ mt: 2, mb: 5 }}>
    <video
      src={file.startsWith("http") ? file : `/help_guide/${file}`}
      controls
      autoPlay
      style={{
        width: "100%",
        maxHeight: "600px",
        borderRadius: "8px",
        background: "#000",
      }}
    />
  </Box>
)}

      </DialogContent>
    </Dialog>
  );
};


export default MarkdownViewerModal;